'use client';
import { CSSProperties, useState } from 'react';
import style from './index.module.scss'
import CloseGray from '@/assets/icons/closeGray.svg'
import StarEmpty from "@/assets/icons/hollowStar.svg";
import EmptyStar from "@/assets/icons/Star.svg";
import { fetchFeedbackCheck } from '@/apis/feedback/feedback.api';
import { useTranslation } from '@/i18n/client';

interface PropsType {
  scoreNum?: number
  onClickStar?: (item: number) => void
  onClose?: (star: number) => void
  containerStyle?: CSSProperties
  shouldReportStarScore?: boolean
  sourceType: number
  title: string
  starWidth?: number
}
const FeedbackStar = ({ 
  containerStyle, 
  scoreNum = 0, 
  onClickStar, 
  onClose, 
  title, 
  sourceType,
  starWidth = 40
}: PropsType) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(true);
  const [star, setStar] = useState(scoreNum)
  const [hoverStar, setHoverStar] = useState(0)
  const handleClose = async () => {
    setShow(false);
    onClose && onClose(star);
    const res = await fetchFeedbackCheck({ sourceType, actionType: 2 })
    if (res.code === '200') {
      console.log('sxt-close 关闭成功');
    } else {
      console.log('sxt-close 关闭失败');
    }
  }

  const handleMouse = (item: number) => {
    setHoverStar(item)
  }

  const handleClickStar = (item: number) => {
    setStar(item)
    onClickStar && onClickStar(item);
  }

  return show && (
    <div className={style.feedbackStar} style={containerStyle}>
      <div className={style.title}>
        <span>{title}</span>
        <CloseGray
          className={style.closeIcon}
          width={16} height={16}
          onClick={handleClose}
        />
      </div>
      <div className={style.stars}>
        {
          [1, 2, 3, 4, 5].map((item, index) => {
            return (
              <div
                className={style.star}
                onMouseEnter={() => handleMouse(item)}
                onMouseLeave={() => setHoverStar(0)}
                onClick={() => handleClickStar(item)}
                key={item}
              >
                {
                  hoverStar > 0 ?
                    hoverStar >= item ? <EmptyStar width={starWidth} height={starWidth}></EmptyStar> :
                      <StarEmpty width={starWidth} height={starWidth}></StarEmpty> :
                    star >= item ? <EmptyStar width={starWidth} height={starWidth}></EmptyStar> :
                      <StarEmpty width={starWidth} height={starWidth}></StarEmpty>
                }
              </div>
            )
          })
        }
      </div>
      <div className={style.text}>
        <span>{t('feedback.Poor')}</span>
        <span>{t('feedback.Great')}</span>
      </div>
    </div>
  )
}

export default FeedbackStar;
